import { useQuery } from "react-query";
import { CategoryRaw, getAllowedCategories, getCategories } from "../services/api";

export interface CategoryItem {
  value: string;
  label: string;
  description: string;
}

function formatCategoryLabel(name: string): string {
  const s = (name ?? "").replace(/_/g, " ").toLowerCase();
  return s ? s[0].toUpperCase() + s.slice(1) : "";
}

function toCategoryItem(raw: CategoryRaw): CategoryItem {
  return {
    value: raw.value,
    label: formatCategoryLabel(raw.value),
    description: raw.description ?? "",
  };
}

export function useCategories() {
  return useQuery<CategoryItem[], Error>(
    "categories",
    async () => {
      const raw = await getCategories();
      return raw
        .map(toCategoryItem)
        .sort((a, b) => a.value.localeCompare(b.value, "it", { sensitivity: "base" }));
    },
    {
      staleTime: 1000 * 60 * 5,
      cacheTime: 1000 * 60 * 10,
    }
  );
}

/**
 * Sottoinsieme delle categorie che l'utente corrente può usare in upload/Golden
 * Standard (tutte se nessuna restrizione è stata configurata da un admin).
 */
export function useAllowedCategories() {
  return useQuery<CategoryItem[], Error>(
    "categories-allowed",
    async () => {
      const raw = await getAllowedCategories();
      return raw
        .map(toCategoryItem)
        .sort((a, b) => a.value.localeCompare(b.value, "it", { sensitivity: "base" }));
    },
    {
      staleTime: 1000 * 60 * 5,
      cacheTime: 1000 * 60 * 10,
    }
  );
}
